const datasetSubscriptionActions = {
  TOGGLE_DATASET_SUBSCRIBE: 'TOGGLE_DATASET_SUBSCRIBE',
  TOGGLE_DATASET_SUBSCRIBE_ERROR: 'TOGGLE_DATASET_SUBSCRIBE_ERROR',
  TOGGLE_DATASET_SUBSCRIBE_SUCCESS: 'TOGGLE_DATASET_SUBSCRIBE_SUCCESS',
};

export default datasetSubscriptionActions;
